import * as api from '../../../api/user/userApi';
import {
  FETCH_USERS_REQUEST,
  FETCH_USERS_SUCCESS,
  FETCH_USERS_FAILURE,
  CREATE_USER,
  UPDATE_USER,
  DELETE_USER
} from '../../types/user/userTypes';

export const fetchUsers = () => async (dispatch) => {
  dispatch({ type: FETCH_USERS_REQUEST });
  try {
    const response = await api.fetchUsers();
    dispatch({ type: FETCH_USERS_SUCCESS, payload: response.data });
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'Failed to fetch users';
    dispatch({ type: FETCH_USERS_FAILURE, payload: errorMessage });
    throw new Error(errorMessage);
  }
};

export const createUser = (data) => async (dispatch) => {
  try {
    const response = await api.createUser(data);
    const newUser = { id: response.data.id, ...response.data.data };
    dispatch({ type: CREATE_USER, payload: newUser });
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'Failed to create user';
    throw new Error(errorMessage);
  }
};

export const updateUser = (id, data) => async (dispatch) => {
  try {
    const response = await api.updateUser(id, data);
    dispatch({ type: UPDATE_USER, payload: { id, data } });
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'Failed to update user';
    throw new Error(errorMessage);
  }
};

export const deleteUser = (id) => async (dispatch) => {
  try {
    const response = await api.deleteUser(id);
    dispatch({ type: DELETE_USER, payload: id });
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'Failed to delete user';
    throw new Error(errorMessage);
  }
};
